function SkilsParagraph() {
    return (
        <div>
            <h2 className = "Sub-header-text mb-5">What I can do for you</h2>
                        <p className='Paragraph-text mb-5'>The experience with various technologies I gained while pursuing my degree in Computational Media combined with my 
                            previous work experience as a Tech QA for Tastypill has given me a great foundation of skills that are applicable to various front and backend positions in software development. 
                            I am a thorough software tester with strong communication skills that allow me to create detailed documents for any software-related issues.  
                            I have previous experience with Flutter, React.js, and express/Node.js, and can pick up new technologies/frameworks extremely fast.
                            I would be a great fit for many positions in software development ranging from UX/UI design all the way to backend development.
                        </p>
                        <p className='Paragraph-text mb-5'>
                            I would be a great fit for many positions in software development ranging from UX/UI design all the way to backend development.
                        </p>
                        <p className='Paragraph-text mb-5'>
                            Popular Technologies I’ve used: <strong>React, MongoDB, Flutter</strong>
                        </p > 
                        <p className='Paragraph-text mb-5'>
                            Technologies I am currently interested in/Learning : <strong>.NET(asp), Web3</strong>
                        </p>
        </div>
    )
}

export default SkilsParagraph;